import React, { useState, useEffect } from 'react'
import { Input, Space, Radio, Selector, Toast } from 'antd-mobile'

const NewForm = (props) => {
    const { userInfo, onSubmit } = props || {};
    // 是否圈内人
    const [insider, setInsider] = useState(2);
    // 昵称
    const [nickName, setNickName] = useState('');
    // 职位
    const [position, setPosition] = useState('');
    // 品牌
    const [brandName, setBrandName] = useState('');

    useEffect(() => {
        if(userInfo.nickname){
            setNickName(userInfo.nickname);
        }
    }, [JSON.stringify(userInfo)]);

    const handleSubmit = () => {
        let msg = '';
        if(insider === 1){
            if(!brandName || !brandName.trim()){
                msg = '请选择企业品牌';
            }
            if(!msg && !position && position.length === 0){
                msg = '请选择职位';
            }
        }
        if(msg){
            Toast.show({
                content: msg,
            })
            return false;
        }
        onSubmit && onSubmit({
            insider,
            nickName,
            position: position ? (position[0] || '') : '',
            brandName
        })
    }

    return (
        <>
            <div className='christmas2023-newForm' style={{ backgroundColor: '#ab282e', padding: '10px' }}>
                <div className='formContainer'>
                    <div className="formStyles" title='单选是否圈内'>
                        <h4>1. 您是物流地产圈内人士吗？</h4>
                        <Radio.Group onChange={setInsider} value={insider}>
                            <Space direction='horizontal'>
                                <Radio value={1} style={{ fontWeight: 700, color: '#000' }}>是</Radio>
                                <Radio value={2} style={{ fontWeight: 700, color: '#000' }}>否</Radio>
                            </Space>
                        </Radio.Group>
                    </div>

                    {insider === 2 ? (<div className="formStyles" title='用户昵称'>
                        <h4>可以修改昵称哦</h4>
                        <Input placeholder='可以你的昵称哦' value={nickName} onChange={setNickName} />
                    </div>) : (<><div className="formStyles" title='选择企业品牌'>
                        <h4>2. 请输入您所就职的企业</h4>
                        <Input placeholder='企业品牌名称' value={brandName} onChange={setBrandName} />
                        <p>剧透：如参与人数超过200，我们将以品牌为统计单位，分享不同物流地产运营商的测试结果，看看品牌调性、企业文化对团队的影响力到底有多大？</p>
                        {/* <Space align='center'>
                            <Button style={{backgroundColor:'#ffda69', color:'#000000', fontSize: 12, fontWeight:700}}
                            onClick={() => setVisible(true)}>
                                点我选择企业品牌
                            </Button>
                            <span className='spanStyle' style={{fontWeight:700}}>你选择了 {selected}</span>
                        </Space>
                        <Popup
                            visible={visible}
                            onMaskClick={() => {
                                setVisible(false)
                            }}
                            destroyOnClose
                        >
                            <div className={styles.checkListContainer}>
                                <CheckList
                                    className={styles.myCheckList}
                                    defaultValue={selected ? [selected] : []}
                                    onChange={val => {
                                        setSelected(val[0])
                                        setVisible(false)
                                    }}
                                >
                                    {filteredItems.map(item => (
                                        <CheckList.Item key={item} value={item}>
                                            {item}
                                        </CheckList.Item>
                                    ))}
                                </CheckList>
                            </div>
                        </Popup> */}
                    </div>

                        <div className="formStyles" title='职位'>
                            <h4>3. 请选择您的职位</h4>
                            <Selector
                                options={[
                                    { label: '租赁', value: '租赁' },
                                    { label: '投资', value: '投资' },
                                    { label: '资管', value: '资管' },
                                    { label: '物管', value: '物管' },
                                    { label: '工程', value: '工程' },
                                    { label: '法务', value: '法务' },
                                    { label: '人事', value: '人事' },
                                    { label: '行政', value: '行政' },
                                    { label: '管理层', value: '管理层' },
                                    { label: '财务', value: '财务' },
                                    { label: '采购', value: '采购' },
                                    { label: '方案与设计', value: '方案与设计' },
                                    { label: '其他', value: '其他' },
                            
                                ]}
                                value={position}
                                onChange={setPosition}
                            />
                        </div>
                        <div className="formStyles" title='用户昵称'>
                            <h4>修改昵称</h4>
                            <Input placeholder='可以你的昵称哦' value={nickName} onChange={setNickName} />
                        </div>
                    </>)}
                    <button className="overlaySubButton" onClick={handleSubmit}>
                        立即提交<br />查看结果
                    </button>
                </div>

            </div>

        </>
    )
}

export default NewForm;